// extracted by mini-css-extract-plugin
export default {"root":"longTermGoal_root__m1+dI","exceeded":"longTermGoal_exceeded__iwZS9"};